<div class="modal-header border-bottom-0 pb-0">
  <h4 class="modal-title fw-bold" id="modal-basic-title">Download Options</h4>
  <div (click)="close()" class="close cursor-pointer">
    <img src="../../../../assets/Images/organisation-structure/Cross.svg" alt="close">
  </div>
</div>

<div class="modal-body pb-4">
  <!-- File Info -->
  <div class="file-info-card d-flex align-items-center mb-4">
    <div class="file-icon-box d-flex align-items-center justify-content-center me-3 flex-shrink-0">
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none"
        stroke="#4a72d4" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14 2 14 8 20 8"></polyline>
      </svg>
    </div>
    <div class="w-100 overflow-hidden">
      <div class="fw-semibold text-truncate" [title]="fileName">{{ fileName }}</div>
      <div class="text-muted small mt-1">PDF Document</div>
    </div>
  </div>

  <form [formGroup]="downloadForm">
    @if (downloadForm.get('downloadType')?.value !== 'COMPRESS') {
      <div class="option-cards-grid mb-4">
        @for (opt of options; track opt.value) {
          <div class="option-card"
            [class.selected]="downloadForm.get('downloadType')?.value === opt.value"
            (click)="downloadForm.get('downloadType')?.setValue(opt.value)">
            <div class="option-header">
              @switch (opt.value) {
                @case ('FULL') {
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                    <polyline points="14 2 14 8 20 8"/>
                    <line x1="16" y1="13" x2="8" y2="13"/>
                    <line x1="16" y1="17" x2="8" y2="17"/>
                  </svg>
                }
                @case ('RANGE') {
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <line x1="8" y1="6" x2="21" y2="6"/>
                    <line x1="8" y1="12" x2="21" y2="12"/>
                    <line x1="8" y1="18" x2="21" y2="18"/>
                    <line x1="3" y1="6" x2="3.01" y2="6"/>
                    <line x1="3" y1="12" x2="3.01" y2="12"/>
                    <line x1="3" y1="18" x2="3.01" y2="18"/>
                  </svg>
                }
                @case ('PAGE_COUNT') {
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <rect x="3" y="3" width="7" height="7"/>
                    <rect x="14" y="3" width="7" height="7"/>
                    <rect x="14" y="14" width="7" height="7"/>
                    <rect x="3" y="14" width="7" height="7"/>
                  </svg>
                }
                @case ('FILE_SIZE') {
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                    <polyline points="7 10 12 15 17 10"/>
                    <line x1="12" y1="15" x2="12" y2="3"/>
                  </svg>
                }
                @case ('COMPRESS') {
                  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18"
                    viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                    stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="4 14 10 14 10 20"/>
                    <polyline points="20 10 14 10 14 4"/>
                    <line x1="10" y1="14" x2="21" y2="3"/>
                    <line x1="3" y1="21" x2="14" y2="10"/>
                  </svg>
                }
              }
              <span class="option-label">{{ opt.label }}</span>
            </div>
            <div class="option-desc">{{ opt.description }}</div>
          </div>
        }
      </div>

      @if (!hasExtraOptions) {
        <div class="no-options-hint text-muted small mb-3">
          Only full-document download is available for this document type.
        </div>
      }
    }

    @if (downloadForm.get('downloadType')?.value === 'COMPRESS') {
      <div class="compress-body">
        <div class="compress-back mb-3" (click)="downloadForm.get('downloadType')?.setValue('FULL')">
          <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
            fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="15 18 9 12 15 6"/>
          </svg>
          <span>Back to options</span>
        </div>

        <div class="compress-label mb-3">Choose Compression Level</div>

        <div class="compression-levels">
          @for (level of compressionLevels; track level.value) {
            <label class="compression-option"
              [class.active]="downloadForm.get('compressionLevel')?.value === level.value">
              <input
                type="radio"
                formControlName="compressionLevel"
                [value]="level.value"
                class="compression-radio" />
              <span class="compression-option-content">
                <span class="compression-option-label">{{ level.label }}</span>
                <span class="compression-option-hint">{{ level.hint }}</span>
              </span>
            </label>
          }
        </div>
      </div>
    }

    @if (downloadForm.get('downloadType')?.value !== 'FULL' && downloadForm.get('downloadType')?.value !== 'COMPRESS') {
      <div class="input-action-row align-items-start">

        <div class="input-action-field">
          @if (downloadForm.get('downloadType')?.value === 'RANGE') {
            <app-input-filed
              label="Page Ranges"
              placeholder="e.g. 1, 3, 5-10, 12"
              [control]="$any(downloadForm).controls['pageRange']">
            </app-input-filed>
            <div class="range-hint mt-1">
              Comma-separated pages or ranges like <strong>1, 3, 5-10</strong>
              @if (totalPages) { — max: <strong>{{ totalPages }}</strong> }
            </div>
            @if (downloadForm.get('pageRange')?.dirty) {
              @if (downloadForm.get('pageRange')?.hasError('rangeFormat')) {
                <div class="validation-error mt-1">
                  <ng-container *ngTemplateOutlet="errIcon"></ng-container>
                  Invalid format. Use numbers or ranges like <strong>1, 3, 5-10</strong>.
                </div>
              }
              @if (downloadForm.get('pageRange')?.hasError('rangeOrder')) {
                <div class="validation-error mt-1">
                  <ng-container *ngTemplateOutlet="errIcon"></ng-container>
                  Start page must be ≤ end page in each range.
                </div>
              }
              @if (downloadForm.get('pageRange')?.hasError('rangeExceeds')) {
                <div class="validation-error mt-1">
                  <ng-container *ngTemplateOutlet="errIcon"></ng-container>
                  Page exceeds total pages ({{ totalPages }}).
                </div>
              }
            }
          }

          @if (downloadForm.get('downloadType')?.value === 'PAGE_COUNT') {
            <app-input-filed
              label="Pages per file"
              [placeholder]="totalPages ? 'Max ' + totalPages : 'e.g. 10'"
              [control]="$any(downloadForm).controls['pageCount']"
              allowedType="number">
            </app-input-filed>
            @if (totalPages) {
              <div class="range-hint mt-1">Max <strong>{{ totalPages }}</strong> pages per file</div>
            }
            @if (downloadForm.get('pageCount')?.dirty && downloadForm.get('pageCount')?.hasError('pageCountExceeds')) {
              <div class="validation-error mt-1">
                <ng-container *ngTemplateOutlet="errIcon"></ng-container>
                Cannot exceed total pages ({{ totalPages }}).
              </div>
            }
          }

          @if (downloadForm.get('downloadType')?.value === 'FILE_SIZE') {
            <app-input-filed
              [label]="'Max file size (' + fileSizeUnit + ')'"
              [placeholder]="maxFileSizeDisplay ? 'Max ' + maxFileSizeDisplay : 'e.g. 5'"
              [control]="$any(downloadForm).controls['fileSize']"
              allowedType="number">
            </app-input-filed>
            @if (maxFileSizeDisplay) {
              <div class="range-hint mt-1">File size: <strong>{{ maxFileSizeDisplay }}</strong></div>
            }
            @if (downloadForm.get('fileSize')?.dirty && downloadForm.get('fileSize')?.hasError('sizeExceeds')) {
              <div class="validation-error mt-1">
                <ng-container *ngTemplateOutlet="errIcon"></ng-container>
                Cannot exceed file size ({{ maxFileSizeDisplay }}).
              </div>
            }
          }
        </div>

        <div class="input-action-buttons">
          <app-common-button buttonClass="smallbutton" buttonLabel="Cancel" (clickEvent)="close()">
          </app-common-button>
          <app-common-button buttonClass="smallFilledButton" [buttonLabel]="actionButtonLabel"
            [disabled]="downloadForm.invalid" (clickEvent)="download()">
          </app-common-button>
        </div>

      </div>
    }

    <!-- FULL option: just buttons -->
    @if (downloadForm.get('downloadType')?.value === 'FULL') {
      <div class="full-action-row">
        <div class="btn-group-row">
          <app-common-button buttonClass="smallbutton" buttonLabel="Cancel" (clickEvent)="close()">
          </app-common-button>
          <app-common-button buttonClass="smallFilledButton" [buttonLabel]="actionButtonLabel"
            [disabled]="downloadForm.invalid" (clickEvent)="download()">
          </app-common-button>
        </div>
      </div>
    }

    @if (downloadForm.get('downloadType')?.value === 'COMPRESS') {
      <div class="full-action-row">
        <div class="btn-group-row">
          <app-common-button buttonClass="smallbutton" buttonLabel="Cancel" (clickEvent)="close()">
          </app-common-button>
          <app-common-button buttonClass="smallFilledButton" [buttonLabel]="actionButtonLabel"
            [disabled]="downloadForm.invalid" (clickEvent)="download()">
          </app-common-button>
        </div>
      </div>
    }

  </form>
</div>

<ng-template #errIcon>
  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24"
    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
    <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
    <line x1="12" y1="16" x2="12.01" y2="16"/>
  </svg>
</ng-template>
